import { createApp } from 'vue';
import Cr2ToWebpConverter from '../Components/Cr2ToWebpConverter.vue';

const root = document.getElementById('cr2-to-webp-converter');
if (root) {
  createApp(Cr2ToWebpConverter).mount('#cr2-to-webp-converter');
}
